import type { Tournament, TournamentInit } from '../types.js';

export function createTournament(init: TournamentInit): Tournament {
  return {
    id: init.id,
    init: { ...init },
    name: init.name,
    status: 'draft',
    seed: init.seed,
    courts: [],
    competitions: [],
    counters: {},
    log: [],
  };
}

/** Kurzname für Etikett/Beamer/Bracket (docs/03): max. ~18 Zeichen */
export function shortenName(name: string, max = 18): string {
  const trimmed = name.trim().replace(/\s+/g, ' ');
  if (trimmed.length <= max) return trimmed;
  const parts = trimmed.split('/').map((p) => p.trim());
  if (parts.length > 1) {
    const each = Math.max(3, Math.floor((max - 1) / parts.length));
    const joined = parts.map((p) => (p.length > each ? p.slice(0, each - 1) + '.' : p)).join('/');
    if (joined.length <= max) return joined;
  }
  return trimmed.slice(0, max - 1) + '…';
}

export class EngineError extends Error {
  constructor(
    message: string,
    public readonly warnings: string[] = [],
  ) {
    super(message);
    this.name = 'EngineError';
  }
}
